import * as React from 'react';

import { translate } from '~l10n/client';

import platform from '../../../../../../shared/Platform';
import { FocusIndicator } from '../FocusIndicator/FocusIndicator';
import { MathField } from './MathField';

interface Props {
  className?: string;
  autofocus?: boolean;
  latex: string;
  onChange?: (latex: string) => void;
  defaultMode?: 'math' | 'text';
}

const MathLiveEditor = ({ onChange, defaultMode = 'math', latex }: Props) => {
  return (
    <div>
      <MathField
        latex={latex}
        defaultMode={defaultMode}
        virtualKeyboardMode={platform.isMobileOrTablet() ? 'onfocus' : 'manual'}
        onChange={onChange}
        autofocus
      />
      <div className="pt-6 pb-0 text-sm text-blue-600 leading-8">
        {translate(
          'To insert math and chemical equations, you can use the virtual keyboard, copy and paste or type \\ to use LaTeX commands.'
        ) + ' '}
        <a
          className="group relative text-cyan-700 hocus:text-cyan-600 rounded-1 no-underline outline-none"
          href="https://help.socrative.com/en/articles/6574271-equation-editor"
          target="_blank"
          rel="noopener noreferrer"
        >
          <FocusIndicator />
          {translate('Learn More')}
        </a>
      </div>
    </div>
  );
};

export default MathLiveEditor;
